import React, { useEffect, useState } from "react";
 import { toast } from "react-hot-toast";
import LoadingSpinner from '../components/LoadingSpinner';

import { PencilIcon, TrashIcon } from "@heroicons/react/solid";
import {
  AddRolePermission,
  fetchPermissions,
  fetchUserRoles,
  updateRolePermission,
  deleteRolePermission, // Assuming you have a delete function in your API service
} from "../services/apiService";
import ConfirmationDialog from "../components/ConfirmationDialog";

export default function RolePermissionsPage() {
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [permissions, setPermissions] = useState([]);
  const [roles, setRoles] = useState([]);
  const [editingPermission, setEditingPermission] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    permissionPath: "",
    role: "",
  });
const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 10; // You can adjust this as needed

  // New state for filters
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedRoleFilter, setSelectedRoleFilter] = useState("");

    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [permissionToDelete, setPermissionToDelete] = useState(null);
  const [confirmConfig, setConfirmConfig] = useState({
    title: "",
    message: "",
    type: "delete",
  });
 
  useEffect(() => {
    const loadInitialData = async () => {
      try {
        await Promise.all([loadPermissions(), loadRoles()]);
      } finally {
        setIsPageLoading(false);
      }
    };
    loadInitialData();
  }, []);
useEffect(() => {
  setCurrentPage(1); // reset to first page when filters change
}, [searchTerm, selectedRoleFilter]);

  const loadPermissions = async () => {
    try {
      const data = await fetchPermissions();
      setPermissions(data);
    } catch (err) {
      console.error("Failed to fetch permissions", err);
      toast.error("Failed to load permissions.");
    }
  };

  const loadRoles = async () => {
    try {
      const data = await fetchUserRoles();
      setRoles(data);
    } catch (err) {
      console.error("Failed to fetch roles", err);
      toast.error("Failed to load roles.");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    
    const { permissionPath, role } = formData;
    const normalizedRole = role.toLowerCase().replace(/\s+/g, '');
    

    if (!permissionPath.trim() || !role) {
      toast.warn("Both permission path and role are required.");
      return;
    }

    try {
     
      if (editingPermission) {
        await updateRolePermission({
          id: editingPermission.id,
          permissionPath,
          role,
        });
        toast.success("Permission updated successfully.");
      } else {
        await AddRolePermission({ permissionPath, role:normalizedRole });
        toast.success("Permission added successfully.");
      }

      setFormData({ permissionPath: "", role: "" });
      setEditingPermission(null);
      setShowModal(false);
      loadPermissions();
    } catch (err) {
      console.error("Error saving permission", err);
      toast.error("Failed to save permission.");
    }
  };

  const handleEdit = (perm) => {
    setEditingPermission(perm);
    setFormData({
      permissionPath: perm.permissionPath,
      role: perm.role,
    });
    setShowModal(true);
  };

  const handleAddNew = () => {
    setEditingPermission(null);
    setFormData({ permissionPath: "", role: "" });
    setShowModal(true);
  };

  // Delete handler
 const handleDeleteClick = (permission) => {
    setPermissionToDelete(permission);
    setConfirmConfig({
      title: "Delete Permission",
      message: `Are you sure you want to delete permission "${permission.permissionPath}" for role "${permission.role}"? This action cannot be undone.`,
      type: "delete",
    });
    setShowConfirmDialog(true);
  };
  const handleConfirmDelete = async () => {
    if (!permissionToDelete) return;

    try {
      await deleteRolePermission(permissionToDelete.id);
      toast.success("Permission deleted successfully.");
      loadPermissions();
    } catch (err) {
      console.error("Error deleting permission", err);
      toast.error("Failed to delete permission.");
    } finally {
      setPermissionToDelete(null);
    }
  };
  // Filter logic
// 1. First, filter the permissions
 const filteredPermissions = permissions.filter((perm) => {
    const matchesSearch = perm.permissionPath
      .toLowerCase()
      .includes(searchTerm.toLowerCase());

    const matchesRole = selectedRoleFilter
      ? perm.role.toLowerCase().trim() === selectedRoleFilter.toLowerCase().replace(/\s+/g, '')
      : true;

    return matchesSearch && matchesRole;
  });


// 2. Then slice the filtered list for pagination
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentItems = filteredPermissions.slice(indexOfFirstItem, indexOfLastItem);


  if (isPageLoading) return <LoadingSpinner label="Loading Permissions" />;

  return (


       <div className="flex flex-col  2xl:px-[10%] pt-8 bg-white xl:pt-24 md:pt-8 md:rounded-t-[40px] xl:rounded-t-[48px] mx-4 h-[70vh] sm:h-[72vh] md:h-[74.5vh] lg:h-[74.5vh] xl:px-[calc(8%-1rem)] 3xl:px-[calc(8%-1rem)] 4xl:[padding-inline:calc(9.5%-1rem)] md:px-[calc(5%-1rem)]">

    <div className='bg-white rounded-2xl p-6   filter drop-shadow-[0_5px_30px_rgba(10,60,96,0.10)]  h-[70vh] sm:h-[65vh] md:h-[68vh] lg:h-[63vh] xl:h-[90vh] overflow-y-auto relative xl:-top-[160px]'>
  
       
  

       <div className="flex flex-col sm:flex-col md:flex-row md:items-center md:gap-4 xl:gap-6 w-full">
  {/* Title */}
  <h3 className="text-xl sm:text-2xl text-primary-800 font-semibold mb-4 md:mb-0">
    Permission Details
  </h3>

  {/* Controls */}
  <div className="flex flex-wrap sm:gap-4 md:flex-nowrap md:gap-4 ml-auto w-full md:w-auto">
    {/* Department Dropdown */}
 

      <select
            className="w-full sm:w-auto md:w-auto bg-white text-gray-600 font-semibold rounded-xl border border-gray-500 focus:outline-none focus:ring-1 focus:ring-primary-600 px-3 py-2"
          value={selectedRoleFilter}
          onChange={(e) => setSelectedRoleFilter(e.target.value)}
        >
          <option value="">All Roles</option>
          {roles.map((role) => (
              <option key={role.role} value={role.role}>
                {role.role}
              </option>
            ))}
        </select>

    {/* Year Dropdown */}
 

    {/* Search Input */}
    <div className="w-full sm:w-auto md:flex-1 flex items-center">
      <input
        type="text"
        className="w-full sm:w-auto md:w-auto bg-white text-gray-600 font-semibold rounded-xl border border-gray-500 focus:outline-none focus:ring-1 focus:ring-primary-600 px-3 py-2"
        placeholder="Search Demand plan by Department, Company or Role..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </div>

  

    {/* Add New Button */}
    
      <button
        onClick={handleAddNew}
        className="w-full sm:w-auto md:w-auto bg-primary-800 text-white px-6 py-2 rounded-xl text-base xl:text-lg"
      >
        + Add New Permission Level
      </button>
  
  </div>
</div>


 


  

      {/* Table */}
     <div className="overflow-x-auto pt-6">
        <table className="min-w-full table-auto border-collapse">
          <thead className="bg-[#f5f3ef] text-primary-600 py-2 px-2 border-r border-primary-500/20 bg-primary-800/10 text-primary-800 text-left ">
      <tr>
              <th className="py-3 px-4 border-r border-primary-500/20">Permission Path</th>
              <th className="py-3 px-4 border-r border-primary-500/20">Role</th>
              <th className="py-3 px-4 border-r border-primary-500/20">Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((perm,index) => (
                          <tr
        key={perm.department_id}
        className={`${
          index % 2 === 0 ? "bg-white" : "bg-primary-800/10"
        } hover:bg-gray-50 transition border-b text-sm text-primary-600`}
      >  
                <td className="px-4 py-2 border-r text-[#232323]">{perm.permissionPath}</td>
                <td className="px-4 py-2 border-r text-[#232323]">{perm.role}</td>
                <td className="px-4 py-2 border-r text-[#232323] text-center">
                 
              <button
                  onClick={() => handleDeleteClick(perm)}
                  className="bg-red-500 text-white p-2 rounded-full hover:bg-red-600 ml-2 transition-colors"
                  title="Delete"
                >
                  <TrashIcon className="h-5 w-5 inline-block" />
                </button>
                </td>
              </tr>
            ))}
            {currentItems.length === 0 && (
              <tr>
                <td colSpan={3} className="text-center text-gray-500 py-4">
                  No permissions found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {/* Pagination Controls */}
{filteredPermissions.length > itemsPerPage && (
  <div className="flex justify-center items-center mt-4 space-x-2 mt-6 mb-6">
    <button
      onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
      className="px-3 py-1 bg-[#f5f3ef] text-primary-600 rounded disabled:opacity-50"
      disabled={currentPage === 1}
    >
      Previous
    </button>
    {Array.from({ length: Math.ceil(filteredPermissions.length / itemsPerPage) }).map((_, index) => (
      <button
        key={index}
        onClick={() => setCurrentPage(index + 1)}
        className={`px-3 py-1 rounded ${
          currentPage === index + 1 ? "bg-primary-600 text-white" : "bg-white text-primary-600"
        } border`}
      >
        {index + 1}
      </button>
    ))}
    <button
      onClick={() =>
        setCurrentPage((prev) => Math.min(prev + 1, Math.ceil(filteredPermissions.length / itemsPerPage)))
      }
      className="px-3 py-1 bg-[#f5f3ef] text-primary-600 rounded disabled:opacity-50"
      disabled={currentPage === Math.ceil(filteredPermissions.length / itemsPerPage)}
    >
      Next
    </button>
  </div>
)}

      </div>

      {/* Modal */}
    
       <footer className="w-full bg-[#f5f3ef] text-primary-600 py-4 px-6 mt-auto shadow-inner mt-6">
  <div className="flex flex-col md:flex-row justify-between items-center text-sm">
    <span className="mb-2 md:mb-0">&copy; {new Date().getFullYear()} Digital & Transformation Department. All rights reserved.</span>
    <div className="flex space-x-4">
      <a   className="hover:underline">Privacy Policy</a>
      <a   className="hover:underline">Terms of Service</a>
    </div>
  </div>
</footer>
    </div>
     <ConfirmationDialog
          isOpen={showConfirmDialog}
          onClose={() => {
            setShowConfirmDialog(false);
            setPermissionToDelete(null);
          }}
          onConfirm={handleConfirmDelete}
          title={confirmConfig.title}
          message={confirmConfig.message}
          type={confirmConfig.type}
          confirmText="Delete"
          cancelText="Cancel"
        />
  {showModal && (
  <div className="fixed inset-0 backdrop-blur-sm flex justify-center items-center z-50 p-4" style={{ backgroundColor: 'rgba(18, 76, 114, 0.2)' }}>
    <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl lg:max-w-3xl" style={{ borderColor: 'rgba(18, 76, 114, 0.1)', borderWidth: '1px' }}>
      {/* Modal Header */}
      <div className="flex items-center justify-between p-6 border-b rounded-t-2xl" style={{ 
        borderColor: 'rgba(18, 76, 114, 0.1)',
        background: 'linear-gradient(to right, rgba(18, 76, 114, 0.05), transparent)'
      }}>
        <h2 className="text-xl font-semibold" style={{ color: 'rgb(18, 76, 114)' }}>
          {editingPermission ? 'Edit Permission' : 'Add New Permission'}
        </h2>
        <button 
          onClick={() => setShowModal(false)} 
          className="transition-all rounded-full p-1.5"
          style={{ color: 'rgba(18, 76, 114, 0.6)' }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'rgb(18, 76, 114)';
            e.currentTarget.style.color = 'white';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.color = 'rgba(18, 76, 114, 0.6)';
          }}
          aria-label="Close"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      {/* Modal Body */}
      <div className="p-6 max-h-[60vh] overflow-y-auto">
        <div className="space-y-6">
          {/* Form Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {/* Permission Path */}
            <div className="space-y-2">
              <label className="block text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                Permission Path <span className="text-red-500">*</span>
              </label>
              <select
                name="permissionPath"
                value={formData.permissionPath}
                onChange={handleChange}
                className="w-full px-3 py-2.5 border rounded-lg outline-none transition text-gray-700"
                style={{ 
                  borderColor: 'rgba(18, 76, 114, 0.3)',
                  backgroundColor: 'white'
                }}
                onFocus={(e) => {
                  e.target.style.boxShadow = '0 0 0 2px rgba(18, 76, 114, 0.2)';
                  e.target.style.borderColor = 'rgb(18, 76, 114)';
                }}
                onBlur={(e) => {
                  e.target.style.boxShadow = 'none';
                  e.target.style.borderColor = 'rgba(18, 76, 114, 0.3)';
                }}
              >
                <option value="">Select a permission path</option>
                <option value="/">Home</option>
                <option value="/department">Department</option>
                <option value="/approval-levels">Approval Levels</option>
                <option value="/profile">Profile</option>
                <option value="/users">Users</option>
                <option value="/roles">Roles</option>
                <option value="/demand-plan">Demand Plan</option>
                <option value="/hiring-request">Hiring Request</option>
                <option value="/sourcing">Sourcing</option>
                <option value="/Candidates">Candidates</option>
                <option value="/evaluation/:id">Evaluation</option>
                <option value="/candidate-details">Candidate Details</option>
                <option value="/interview-short-list">Interview Short List</option>
                <option value="/interview-board">Interview Board</option>
                <option value="/short-list">Short List</option>
                <option value="/hiring-process">Hiring Process</option>
                <option value="/hiring-approval">Hiring Approval</option>
                <option value="/all-hiring-request">All Hiring Request</option>
                <option value="/request-details">Hiring Details</option>
              </select>
            </div>

            {/* Role */}
            <div className="space-y-2">
              <label className="block text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                Role <span className="text-red-500">*</span>
              </label>
              <select
                name="role"
                value={formData.role}
                onChange={handleChange}
                className="w-full px-3 py-2.5 border rounded-lg outline-none transition text-gray-700"
                style={{ 
                  borderColor: 'rgba(18, 76, 114, 0.3)',
                  backgroundColor: 'white'
                }}
                onFocus={(e) => {
                  e.target.style.boxShadow = '0 0 0 2px rgba(18, 76, 114, 0.2)';
                  e.target.style.borderColor = 'rgb(18, 76, 114)';
                }}
                onBlur={(e) => {
                  e.target.style.boxShadow = 'none';
                  e.target.style.borderColor = 'rgba(18, 76, 114, 0.3)';
                }}
              >
                <option value="">Select a role</option>
                {roles.map((role) => (
                  <option key={role.role} value={role.role}>
                    {role.role}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Footer */}
      <div className="flex flex-col sm:flex-row justify-end gap-3 p-6 border-t rounded-b-2xl" style={{ 
        borderColor: 'rgba(18, 76, 114, 0.1)',
        background: 'linear-gradient(to right, transparent, rgba(18, 76, 114, 0.05))'
      }}>
        <button
          onClick={() => setShowModal(false)}
          className="px-5 py-2.5 bg-white border rounded-lg transition-all font-medium"
          style={{ 
            color: 'rgb(18, 76, 114)',
            borderColor: 'rgba(18, 76, 114, 0.3)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'white';
          }}
        >
          Cancel
        </button>
        <button
          onClick={handleSubmit}
          className="px-5 py-2.5 text-white font-medium rounded-lg transition-all"
          style={{ 
            backgroundColor: 'rgb(18, 76, 114)',
            cursor: 'pointer',
            boxShadow: '0 10px 15px -3px rgba(18, 76, 114, 0.2)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.9)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'rgb(18, 76, 114)';
          }}
        >
          {editingPermission ? 'Update Permission' : 'Add Permission'}
        </button>
      </div>
    </div>
  </div>
)}
       </div>
  );
}
